import { useMemo } from 'react';

import { useIsLandscape, useIsLargerThanWide } from '../../../styles/hooks/media';
import { SubtitlesDevice, SubtitlesViewport } from '../types';

export const useSubtitlesViewport = (): { deviceType: SubtitlesDevice; viewport: SubtitlesViewport } => {
  const isLargerThanWide = useIsLargerThanWide();
  const isLandscape = useIsLandscape();

  return useMemo(() => {
    if (isLargerThanWide) {
      return { deviceType: SubtitlesDevice.DESKTOP, viewport: SubtitlesViewport.DESKTOP };
    } else if (isLandscape) {
      return { deviceType: SubtitlesDevice.MOBILE, viewport: SubtitlesViewport.LANDSCAPE };
    } else {
      return { deviceType: SubtitlesDevice.MOBILE, viewport: SubtitlesViewport.PORTRAIT };
    }
  }, [isLandscape, isLargerThanWide]);
};
